module.exports = __webpack_public_path__ + "img/1.0d7713a6.webp";